import { LegacyField } from '../types/LegacyField';
import { requestGet } from '../utils/request';

const BASE_URL = '/api/v4/fields/';

export function requestField(fieldId: string): Promise<LegacyField> {
  return requestGet(`${BASE_URL}${fieldId}?includeBoundary=true`, {
    mockFile: 'field/default',
  });
}
